<template>
  <div class="display">
    <div class="carousel-box">
      <div class="banner_title">软件UI设计</div>
      <div class="banner_content">高端定制·专业设计</div>
    </div>
    <div class="title_box">
      <div class="list_title">
        <div class="title_text" :class="{ title_text: true, active: currentIndex == 1 }" @click="changeText(1)">接单需求
        </div>
        <div class="title_center">|</div>
        <div :class="{ title_text: true, active: currentIndex == 0 }" @click="changeText(0)">案例展示</div>
      </div>
    </div>
    <div v-if="currentIndex == 0">
      <div class="list">
        <!-- v-for="(item, index) in 5" :key="index" -->
        <div class="list_item" v-for="(item, index) in titlex.length - 5" :key="index"
          @click="gotoDisplayDeatil(index)">
          <div class="imgbox">
            <img :src="getImagePath(index)" alt="">
          </div>
          <div class="item_bottom">
            <div class="info">
              <div class="info_left">
                <div class="icon">
                  <img :src="getIconPath(index)" alt="">
                </div>
                <div class="name">{{ titleIcon[paginationIndex][index] }}</div>
              </div>
              <div class="info_right">发布于{{ pmonth[paginationIndex][index] }}天前 </div>
            </div>
            <div class="copyright">
              <div class="copyright_left">
                <div>{{ title[paginationIndex][index] }}</div>
              </div>
              <div class="copyright_right">
                <div></div>
                <div>版权保护中</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="pagination" style="margin: 0 auto;">
        <el-pagination style="margin:0 auto;margin-bottom: 30px;" @current-change="handleCurrentChange" background
          layout="prev, pager, next" :total="8" :page-size="4">
        </el-pagination>
      </div>
    </div>
    <div class="require_list" v-if="currentIndex == 1">
      <el-row :gutter="19">
        <el-col :span="8" v-for="(item, index) in requireList" :key="index">
          <div class=" grid-content bg-purple">
            <div class="require_item" @click="gotoDemand(item)">
              <div class="top1">{{ item.title }}</div>
              <div class="top2">{{ item.nickname }}</div>
              <div class="line"></div>
              <div class="bottom1">
                <div>进行中</div>
                <div>人数需求：{{item.number}}人</div>
              </div>
              <div class="bottom2">
                <div>数量：1</div>
                <div>￥{{ item.price }}</div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
      <!-- <el-row :gutter="17">
        <el-col :span="12" v-for="(item, index) in requireList" :key="index">
          <div class=" grid-content bg-purple">
            <div class="require_item" @click="gotoDemand(item)">
              <div class="top">
                <div class="top_left">
                  <div class="banner">
                    <div class="tips">招募中</div>
                  </div>
                </div>
                <div class="top_right">
                  <div class="title">
                    [商业需求] {{ item.title }}
                  </div>
                  <div class="subhead">原画</div>
                  <div class="price">{{ item.price }}元/张</div>
                  <div class="center">
                    <span>需试稿</span>
                    <span><span style="color: #999999;">稿件数量:</span>{{ item.number }}张</span>
                    <span><span style="color: #999999;">预计总价:</span> ￥{{ item.totalPrice }}</span>
                  </div>
                  <div class="recom">
                    <div class="iconBox">
                      <div class="img_icon"><img src="../assets/picture/cb1efcf9ecae489a919042203f54558b.jpg" alt="">
                      </div>
                      <div class="img_icon"><img src="../assets/picture/0231f477a097436695c0feba99773675.jpg" alt="">
                      </div>
                      <div class="img_icon"><img src="../assets/picture/515c7b6a2276470d83680be2a3776474.jpg" alt="">
                      </div>
                    </div>
                    <div class="text">等{{ point[paginationIndex][index] }}位已推荐&应征</div>
                  </div>
                </div>
              </div>
              <div class="bottom">
                <div class="bottom_left">
                  <div class="name">{{ item.nickname }}</div>
                  <div class="tag">认证个人</div>
                </div>
                <div class="bottom_right">截稿日期： {{ formatDate(item.date) }} </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row> -->
      <div class="pagination" style="margin: 0 auto;">
        <el-pagination style="margin:0 auto;margin-bottom: 30px;" @current-change="requireChange" background
          layout="prev, pager, next" :total="total" :page-size="params.page.page_limit">
        </el-pagination>
      </div>
    </div>
    <!-- <div class="pagination">
      <div class="item"></div>
    </div> -->
    <!-- <Bottom></Bottom> -->
  </div>
</template>

<script>
import { mapState } from "vuex";
import axios from "axios";
import { information_listApi } from "../api/index";
import moment from "moment";
export default {
  data() {
    return {
      // requireList: [{ title: "插画", nicknam: '张三', price: '1000', mobile: '17634447001', number: '30', date: '2025-6-1', totalPrice:'10000'},
      //   { title: "插画2", nicknam: '张三', price: '1000', mobile: '17634447001', number: '30', date: '2025-6-1', totalPrice: '10000' },
      //   { title: "插画3", nicknam: '张三', price: '1000', mobile: '17634447001', number: '30', date: '2025-6-1', totalPrice: '10000' }
      // ],
      requireList: [],
      titleIcon: {
        5: new Array('星语', '悠悠', '奶茶君', '星空旅人', '絮语', '铁蛋', '玄风', '九尾狐', '晨露'),
        4: new Array('COOL', '布丁酱', '徘徊', '云间月影', '梦璃', '袅袅', '方块熊', '冰心', '诗韵'),
        3: new Array('STAR', '墨韵', '书雅', '蜜桃', '智慧精灵', '小熊宝', '晓不知', '解药', '逐梦天涯'),
        0: new Array('kitty', 'lynn', '子轩', '幻梦', '皮卡丘宝', '辰汐', '流年', '喵巷', '蜜桃雪'),
        1: new Array('灵舞', '逸殃', '小仙狐', '云黛', '惶惶', '漫漫', '灵儿', '萌贝比', '逍遥'),
        2: new Array('Z888', 'GTAN', '小太阳', '貂蝉', '杰克', '海加一', '小胖墩', '若莲', '鹅鹅'),
      },
      titlex: new Array('星语', '悠悠', '奶茶君', '星空旅人', '絮语', '铁蛋', '玄风', '九尾狐', '晨露'),
      hot: {
        5: new Array(49, 41, 34, 38, 16, 13, 5, 46, 7, 11),
        4: new Array(22, 27, 24, 27, 12, 11, 43, 17, 43),
        3: new Array(23, 20, 52, 26, 25, 22, 10, 19, 23),
        2: new Array(25, 7, 7, 3, 36, 22, 41, 20, 22),
        1: new Array(40, 6, 5, 42, 14, 41, 5, 30, 28),
        0: new Array(40, 6, 5, 42, 14, 41, 5, 30, 28),
      },
      uname: {
        0: new Array("角色", "角色", "角色", "角色", "角色", "角色", "角色", "角色", "角色"),
        1: new Array("角色", "角色", "角色", "角色", "角色", "角色", "角色", "角色", "角色"),
        2: new Array("角色", "角色", "角色", "角色", "角色", "角色", "角色", "角色", "角色"),
        3: new Array("人物", "人物", "人物", "人物", "人物", "人物", "人物", "人物", "人物"),
        4: new Array("角色", "角色", "角色", "角色", "角色", "角色", "角色", "角色", "角色"),
        5: new Array("头像", "头像", "头像", "头像", "头像", "头像", "头像", "头像", "头像"),
      },
      pmonth: {
        5: new Array(22, 13, 11, 28, 19, 25, 3, 17, 29),
        4: new Array(15, 21, 10, 6, 27, 18, 24, 2, 20),
        3: new Array(4, 26, 12, 7, 14, 5, 23, 8, 16, 9),
        0: new Array(1, 30, 22, 13, 11, 28, 19, 25, 3),
        2: new Array(17, 29, 15, 21, 10, 6, 27, 18, 24),
        1: new Array(2, 20, 4, 26, 12, 7, 14, 5, 23)
      },
      username: {
        5: new Array("z3954306", "小乖不乖", "小蝴蝶飞呀飞", "背影", "乐活", "盖中盖", "波克比", "ROK"),
        4: new Array("五月", "MOMO", "周鹏123", "密码社", "迷失幻境", "一诺出版", "DR8877", "杨憨憨"),
        3: new Array("熊宝BY", "然然", "CHEN", "明天是好天气", "无名", "GSS", "烈酒在喉", "小仙女"),
        2: new Array("渺渺", "梦想", "瓜尔佳之林", "琦琦妈", "克洛伊", "趣酷比", "光军", "zjf"),
        1: new Array("詹小婷", "DIDI", "C先生", "包作舟", "山野纹身师", "小叶同学", "鹌鹑", "奥利奥007"),
        0: new Array("思雨呀", "白山茶", "蛮蛮", "波波大侠", "道童", "艾母鸡", "幻音", "半度微凉"),
      },
      title: {
        5: new Array("ui移动端设计", "情侣头像", "古风女头像", "古风角色原画", "古风言情小说插画", "古风男头像", "二次元头像", "科普杂志插图"),
        4: new Array("二次元闺蜜头像", "二次元游戏角色", "二次元情侣头像", "海洋生物绘本", "二次元角色", "中学作文场景插画", "古风情侣头像", "少儿诗词插图"),
        3: new Array("游戏场景", "国风女头像", "二次元闺蜜头像", "游戏场景", "言情小说封面", "古风场景", "武侠角色原画", "二次元女头像"),
        2: new Array("闺蜜头像", "植物科普插画", "二次元角色", "翻翻书插图", "游戏场景", "游戏场景原画", "古风言情小说插画", "二次元女头像"),
        1: new Array("小程序开发", "ui移动端设计", "H5应用开发", "微信小程序开发", "古风女头像", "二次元情侣头像", "Q版武侠角色", "场景氛围图"),
        0: new Array("ui移动端设计", "微信小程序开发", "app页面设计", "H5应用开发", "二次元男头像", "情侣头像", "国风场景", "卡通情侣头像"),
      },
      price: {
        5: new Array("1500~2000", "100~200", "1500~2000", "3000~5000", "300~500", "80~300", "200~300", "1500~2000"),
        4: new Array("200~300", "1000~2000", "100~500", "150~200", "2000~3000", "100~150", "100~200", "100~120"),
        3: new Array("5000~10000", "300~400", "100~200", "1800~2000", "500~1000", "2000~4000", "4000~5000", "300~500"),
        2: new Array("100~150", "500~800", "2000~4000", "1000~1500", "3000~5000", "2000~4000", "500~800", "200~300"),
        1: new Array("400~500", "200~300", "200~300", "100~300", "1000~2000", "500~800", "100~800", "150~200"),
        0: new Array("1000~1200", "800~1000", "800~1000", "500~800", "150~300", "100~200", "500~800", "200~300"),
        // price7: new Array("3000~8000", "5000~8000", "1000~1200", "200~300", "2000~5000", "180~200", "3000~5000", "800~1000"),
      },
      num: {
        5: new Array("40", "2", "2", "8", "100", "1", "2", "2"),
        4: new Array("1", "10", "2", "100", "15", "40", "1", "240"),
        3: new Array("5", "1", "6", "8", "4", "12", "3", "1"),
        2: new Array("4", "15", "8", "6", "8", "10", "6", "1"),
        1: new Array("1", "4", "120", "1", "6", "6", "1", "1"),
        0: new Array("30", "2", "5", "1", "1", "1", "24", "22"),
      },
      money: {
        5: new Array("70000", "300", "3500", "32000", "40000", "190", "500", "3500"),
        4: new Array("250", "15000", "600", "17500", "37500", "5000", "150", "26400"),
        3: new Array("37500", "350", "900", "15200", "3000", "36000", "13500", "400"),
        2: new Array("500", "9750", "24000", "7500", "32000", "30000", "3900", "250"),
        1: new Array("450", "1000", "30000", "200", "9000", "3900", "450", "175"),
        0: new Array("33000", "1800", "4500", "650", "225", "150", "15600", "5500"),
        // money7: new Array("22000", "104000", "2200", "3000", "3500", "19000", "88000", "14400"),
      },
      point: {
        5: new Array(9, 46, 18, 33, 47, 28, 20, 42),
        4: new Array(33, 39, 17, 42, 42, 40, 16, 13),
        3: new Array(33, 6, 4, 14, 9, 46, 8, 44),
        2: new Array(16, 5, 36, 19, 22, 37, 52, 37),
        1: new Array(13, 41, 32, 32, 40, 50, 47, 4),
        0: new Array(20, 7, 47, 36, 32, 23, 49, 18),
        // point7: new Array(46, 32, 27, 6, 23, 37, 26, 13)
      },
      date: {
        "5": [
          "2025-01-01",
          "2025-09-08",
          "2025-09-30",
          "2025-09-28",
          "2025-09-28",
          "2025-09-25",
          "2025-09-20",
          "2025-09-20"
        ],
        "4": [
          "2025-09-02",
          "2025-09-17",
          "2025-09-15",
          "2025-09-10",
          "2025-08-31",
          "2025-08-31",
          "2025-08-27",
          "2025-08-22"
        ],
        "3": [
          "2025-08-21",
          "2025-08-20",
          "2025-08-19",
          "2025-08-15",
          "2025-08-14",
          "2025-08-12",
          "2025-08-10",
          "2025-08-01"
        ],
        "2": [
          "2025-07-08",
          "2025-07-08",
          "2025-07-05",
          "2025-07-04",
          "2025-07-31",
          "2025-07-28",
          "2025-07-24",
          "2025-07-23"
        ],
        "1": [
          "2025-07-22",
          "2025-07-17",
          "2025-07-15",
          "2025-07-11",
          "2025-06-30",
          "2025-06-30",
          "2025-06-28",
          "2025-06-26"
        ],
        "0": [
          "2025-06-22",
          "2025-06-02",
          "2025-06-17",
          "2025-06-16",
          "2025-06-15",
          "2025-06-01",
          "2025-05-27",
          "2025-05-25"
        ]
      },
      // windowWidth: document.documentElement.clientWidth,
      // banner: {
      //   pcBanner: require('@/assets/updateBanner/pcJoin.png'),
      //   mbBanner: require('@/assets/updateBanner/mbGame.png')
      // },
      windowWidth: document.documentElement.clientWidth,
      banner: {
      },
      img1: ["require(`@/assets/chunk/${this.imageIndex}.png`)"],
      paginationIndex: 0,
      currentArray: [],
      currentIndex: 1,
      currentImg: '',
      params: {
        page: {
          page_num: 1,
          page_limit: 6
        },
        map: { "title": "" },
      },
      total: 0
    }
  },
  computed: {
    // ...mapState(['currentIndex'])
  },
  methods: {
    async getPublishRequire() {
      const res = await information_listApi(this.params)
      if (res.data.code === 1) {
        this.requireList = res.data.data
        console.log("res.data.data", res.data.data);
        
        this.total = res.data.page.data_count
      }
    },
    changeText(val) {
      this.currentIndex = val
      // this.$store.commit('setCurrentIndex', val)
    },
    getImagePath(index) {
      return require(`@/assets/chunk/${this.paginationIndex}/${index + 1}.png`);
    },
    getIconPath(index) {
      return require(`@/assets/creators_files/${this.paginationIndex}/${index + 1}.jpg`);
    },
    handleCurrentChange(val) {
      this.paginationIndex = val - 1
    },
    requireChange(val) {
      this.params.page.page_num = val
      this.getPublishRequire()
    },
    gotoDemand(value) {
      this.$router.push({
        path: '/demandInfo',
        query: {
          date: value.id,
        }
      });
    },
    gotoDisplayDeatil(value) {
      this.$router.push({
        path: '/displayDetail',
        query: {
          src: require(`@/assets/chunk/${this.paginationIndex}/${value + 1}.png`),
        }
      });
      // this.$router.push({
      //   path: '/displayDetail',
      //   query: {
      //     src: require(`@/assets/chunk/${this.paginationIndex}/${value + 1}.png`),
      //   }
      // });
      // this.$router.push('/displayDetail')
    },
    formatDate(value) {
      return moment(value).format("YYYY-MM-DD")
    }
  },
  async created() {
    this.getPublishRequire()
    // if (this.$route.query.id) {
    //   this.currentIndex = 1
    // } else {
    //   this.currentIndex = 0
    // }
  },
  components: {
    // Bottom
  }
}
</script>

<style lang="scss" scoped>
// pc端
// @media (min-width: 992px) {

.display {
  // display: flex;
  padding-top: 75px;
  background-color: #f9fafc !important;

  .carousel-box {
    // width: 1200px;
    // width: 1500px;
    margin: 0 auto;
    height: 450px;
    width: 1200px;
    background-image: url("../assets/lunbo/displayBanner.png");
    background-size: 100% 100%;
    color: #FFFFFF;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .banner_title {
      font-size: 75px;
    }

    .banner_content {
      font-size: 35px;
      margin-top: 23px;
    }
  }

  .title_box {
    margin: 100px 0;
    .list_title {
      box-sizing: content-box;
      width: 680px;
      height: 58px;
      margin: 0 auto;
      font-size: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #3669FF;
      .title_text {
        position: relative;
        width: 155px;
        height: 56px;
        line-height: 51px;
        text-align: center;
        cursor: pointer;
        border: 1px solid #3669ff;

        // &.active::after {
        //   position: absolute;
        //   content: '';
        //   display: block;
        //   width: 100%;
        //   height: 5px;
        //   left: 0;
        //   bottom: 0;
        //   background-color: #580f26;
        //   border-radius: 3px;
        // }

        &.active {
          background-color: #3669ff;
          color: #FFFFFF;
        }
      }

      .title_center {
        margin: 0 100px;
      }
    }
  }

  .list {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;

    .list_item {
      width: 366px;
      height: 449px;
      border-radius: 10px;
      background-color: #ffffff;
      margin-right: 79px;
      margin-bottom: 50px;
      /* 实现底部阴影效果 */
      box-shadow: 0 6px 11px -5px rgba(0, 0, 0, 0.5);

      .imgbox {
        width: 100%;
        height: 283px;
        background: #580f26;
        border-radius: 10px 10px 0 0;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .item_bottom {
        padding: 0 30px;

        .copyright {
          display: flex;
          justify-content: space-between;
          margin-top: 20px;

          .copyright_left {
            font-size: 19px;
            color: #000000;
            font-weight: bold;
          }

          .copyright_right {
            display: flex;
            align-items: center;

            div:nth-child(1) {
              width: 14px;
              height: 16px;
              background-image: url("../assets/display/copyright.png");
              background-size: 100% 100%;
              margin-right: 5px;
            }

          }

        }

        .info {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 41px;

          .info_left {
            display: flex;
            align-items: center;

            .icon {
              width: 30px;
              height: 30px;
              border-radius: 50%;
              margin-right: 10px;

              img {
                width: 100%;
                height: 100%;
                border-radius: 50%;
              }
            }

            .name {}
          }

          .info_right {
            color: #999999;
          }
        }
      }

      &:nth-child(2n) {
        margin-right: 0;
      }
    }

  }

  .require_list {
    width: 1200px;
    margin: 0 auto;

    // display: flex;
    // flex-wrap: wrap;
    .require_item {
      background-color: #ffffff;
      box-sizing: border-box;
      // width: 238px;
      // height: 209px;
      padding: 21px 0px 12px 0px;
      display: flex;
      flex-direction: column;
      align-items: center;
      cursor: pointer;
      .top1 {
        // width: 204px;
        padding: 3px 20px;
        // height: 39px;
        background-color: #d1dcff;
        font-size: 20px;
        color: #3669FF;
        font-weight: bold;
        text-align: center;
        line-height: 39px;
      }

      .top2 {
        width: 220px;
        font-size: 15px;
        color: #000000;
        margin: 16px 0 0 0;
        height: 45px;
        display: -webkit-box;
          /* 关键，设置为弹性盒模型的旧版语法，用于多行截断 */
          -webkit-box-orient: vertical;
          /* 设置盒子内元素垂直排列 */
          -webkit-line-clamp: 2;
          /* 限制显示的行数为 2 行 */
          overflow: hidden;
          /* 超出内容隐藏 */
          text-indent: 2em;
      }

      .line {
        width: 234px;
        height: 1px;
        background-color: #B9B9B9;
        margin: 23px 0;
      }

      .bottom1 {
        display: flex;
        justify-content: space-between;
        width: 234px;

        div:nth-child(1) {
          width: 51px;
          height: 26px;
          background-color: #D1FFD6;
          font-size: 12px;
          color: #3DC26E;
          text-align: center;
          line-height: 26px;
          border-radius: 15px;
        }

        div:nth-child(2) {
          font-size: 12px;
        }
      }

      .bottom2 {
        width: 234px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 11px;
        div:nth-child(1) {
          font-size: 12px;
          color: #A2A2A2;
        }

        div:nth-child(2) {
          font-size: 20px;
          color: #FF2A2A;
        }

      }
    }

    .el-row {
      margin-bottom: 20px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    .el-col {
      border-radius: 4px;
      margin-bottom: 20px;
    }

    .bg-purple-dark {
      // background: #99a9bf;
    }

    .bg-purple {
      // background: #d3dce6;
    }

    .bg-purple-light {
      // background: #e5e9f2;
    }

    .grid-content {
      border-radius: 4px;
      min-height: 36px;
    }

    .row-bg {
      padding: 10px 0;
      // background-color: #f9fafc;
    }
  }

  .pagination {
    .item {
      width: 30px;
      height: 28px;
      background-color: #f4f4f5;
    }
  }
}

// }

@media (max-width: 750px) {}
</style>
